import { ColorMappingService } from "./colorMapping.service";
import { api } from "../../apiProvider";

export const colorMappingAdapter: ColorMappingService = async () => {
    const resp = await api.colorMapping();
    return resp.data;
};
